/* eslint-disable no-unused-expressions */
import React from 'react';
import { useLocation } from '@reach/router';
import { makeStyles, AppBar, Toolbar, IconButton, Badge, Divider } from '@material-ui/core';

import NotificationsOutlinedIcon from 'src/assets/icons/notification.svg';

import GroupsList from './groupsList';
import UserInfo from './userInfo';

const useStyles = makeStyles(theme => ({
  appBar: ({ drawerWidth }) => ({
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  }),
  toolbar: {
    marginLeft: 'auto',
    padding: theme.spacing(4, 3),
    width: 240,
    display: 'flex',
    justifyContent: 'space-evenly',
  },
}));

const Info = () => {
  const { pathname } = useLocation();

  if (pathname.match('integrations') || pathname.match('routing-rules') || pathname.match('users')) {
    return <UserInfo />;
  }
  return <GroupsList />;
};

export default function Header({ drawerWidth }) {
  const classes = useStyles({ drawerWidth });

  return (
    <AppBar position="relative" color="transparent" className={classes.appBar} elevation={0}>
      <Toolbar className={classes.toolbar}>
        <IconButton aria-label="show 17 new notifications" color="inherit">
          <Badge badgeContent={2} color="primary">
            <NotificationsOutlinedIcon color="secondary" />
          </Badge>
        </IconButton>
        <Divider orientation="vertical" flexItem />
        <Info />
      </Toolbar>
    </AppBar>
  );
}
